export enum CouponUsageTypeEnum {
  'Glamgirl' = 0,
  'Glamqueen' = 1,
  'CRM' = 2,
  'Glampartner' = 3,
  'Paid' = 4,
  'Social' = 5,
  'Benefício' = 6
}
